const brQuote = {
  quote: {
    label: {
      title: 'Orçamento',
      name: 'Nome',
      amount: 'Valor',
      category: 'Categoria',
      location: 'Localização',
      quantity: 'Quantidade',
      cardInfo: 'Informações do cartão',
      personalInfo: 'Informações pessoais',
      itemDescription: 'Descrição do item',
      itemDesc: 'Desc. do item',
      serviceDescription: 'Descrição do serviço',
      serviceDesc: 'Desc. do serviço',
      instalmentNumber: 'Parcelas',
      poweredByAlt: 'Powered by Hauseful',
      printableVersion: 'Versão para impressão',
      print: 'Imprimir',
      share: 'Compartilhar',
      accepted: 'Aceito',
      notAccepted: 'Não aceito',
      displayQRCode: 'Visualizar QRCode',
      paymentMethod: 'Método de pagamento',
      qtd: 'Qtd.',
      phone: 'Telefone',
      email: 'E-mail',
      simplifiedPrinting: 'Impressão simplificada',
    },

    modal: {
      pix: 'PIX',
      payWith: 'Pagar com',
      creditCard: 'Cartão de Crédito',
      paymentSelectTitle: 'Selecione a forma de pagamento',
      payWithFciTitle: 'Confirmar aceite de proposta',
      paymentSelected: 'Informações de pagamento',
      availableInstallments: 'Opções de parcelamento',
      seeAvailableInstallments: 'Ver opções de parcelameto',
      availableInstallmentsDescription: 'Você poderá escolher o número de parcelas na hora de pagar.',
      fci: 'FCI',
      installmentTerm: 'Prazo',
      installmentMonthlyValue: 'Valor mensal',
      installmentTotalValue: 'Valor total',
    },

    action: {
      goBack: 'Voltar',
      pay: 'Comprar agora',
      useAnotherMethod: 'Utilizar outro método de pagamento',
      makePayment: 'Finalizar pedido',
      paymentSelect: 'Selecionar forma de pagamento',
      acceptQuote: 'Aceitar orçamento',
    },

    share: {
      subject: 'Orçamento Hauseful',
      message: 'Segue o link para visualizar o orçamento: ',
    },

    hint: {
      withPix: 'no PIX com {discount} de desconto',
      notFound: 'Orçamento não encontrado',
      alreadyPaid: 'Orçamento pago',
      awaitingPayment: 'Aguardando pagamento via PIX',
      addressAndCode: 'Abaixo estão listados os itens referentes ao serviço de reforma que será executada no imóvel {address} com o código {code}',
      afterPaymentGetInTouch: 'Após efetuar o pagamento, nossa equipe entrará em contato para agendar a execução do serviço e tirar possíveis dúvidas.',
      paymentSuccess: 'O pagamento foi efetuado com sucesso!',
      paidWithFci: 'O orçamento foi pago com o saldo do FCI',
      payWithFci: 'O orçamento pode ser pago com o saldo do FCI',
      paymentAcceptedAndPaid: 'Orçamento pago pelo inquilino',
      paymentPaidByBalance: 'Orçamento pago usando saldo',
      paid: 'O orçamento foi pago',
      keyWithTenant: 'Orçamento aceito e aguardando pagamento',
      willBePaidWithFCI: 'Pagamento via FCI com desconto de {value}',
      paymentAmountAndMethod: 'Pagamento de {amount} realizado via {method}',
      paymentMethodWithoutAmount: 'Pagamento realizado via {method}',
      paymentMethodAndFCIWithoutAmount: 'Pagamento realizado via {method} e F.C.I.',
      onSightDiscount: 'Com desconto de pagamento a vista de {discount}',
      installments: 'Em {installments} parcela(s)',
      overdue: 'Este orçamento está vencido',

      totalPayment: 'Total: {summaryTotal}',
      totalPixPayment: 'Pix no valor de {summaryChargedValue}',
      totalInstallment: '{summaryInstallments} parcela de {summaryInstallmentValue}',
      totalInstallments: '{summaryInstallments} parcelas de {summaryInstallmentValue} ({chargedValue})',
      totalFCI: 'F.C.I. utilizado: {summaryFCI}',
    },

    share: {
      title: 'Compartilhamento',
      label: {
        type: 'Tipo',
        sendTo: 'Enviado para',
        shared: 'Compartilhado',
        viewed: 'Visualizado',
      },
      type: {
        PHONE: 'Telefone',
        EMAIL: 'E-mail'
      }
    },

    amount: {
      title: 'Repasses',
      itemsValues: 'Fornecedor',
      splitValues: 'Split',
      showTransfer: 'Visualizar transferência'
    },

    priceTable: {
      subtotal: 'Subtotal',
      fci: 'F.C.I.',
      usedFci: 'F.C.I. utilizado',
      discount: 'Desconto',
      total: 'Total',
      payWithPix: 'PIX',
      totalWithDiscount: 'Total com desconto',
      totalByInstallments: 'ou {totalByInstallments} em até 10x',
      cashDiscount: 'Desconto à vista',
      discountPIXHint: 'no PIX',
      discountPIXAmount: '10% de desconto',
      installments: 'em até {installments}x',
      installmentsNumber: 'no PIX ou em até {installments} vezes',
      singleInstallmentNumber: 'no PIX ou em até {installments} vez no cartão',
      payment: 'Pagamento',
      usingFCI: 'totalmente coberto pelo saldo do F.C.I.',
      usingBalance: 'usando o seu saldo',
      serviceCallFee: 'Visita técnica',
      vendorDiscount: 'Desconto',
      pixTax: 'Taxa de serviço',
      technicalVisitDescription: 'Valor cobrado pela visita técnica e realização de serviços.',
    },
  },
}

export default brQuote
